module.exports = __webpack_public_path__ + "img/p35.eec35ffd.svg";